// The Pendo agent is injected by GTM, which can finish loading after the user
// data resolves (the Authentik session probe is fast), so wait for it.
export const PENDO_POLL_INTERVAL_MS = 250;
export const PENDO_POLL_TIMEOUT_MS = 15000;

let pendingVisitor = null;
let pollTimer = null;

function pendoReady() {
  return typeof window !== 'undefined' && window.pendo && window.pendo.initialize;
}

function sendVisitor(visitor) {
  // This will only run if the user has granted consent to tracking
  window.pendo.initialize({ visitor });
}

function waitForPendo() {
  if (pollTimer) {
    return;
  }

  const startedAt = Date.now();
  pollTimer = setInterval(() => {
    if (pendoReady()) {
      clearInterval(pollTimer);
      pollTimer = null;
      sendVisitor(pendingVisitor);
    } else if (Date.now() - startedAt >= PENDO_POLL_TIMEOUT_MS) {
      clearInterval(pollTimer);
      pollTimer = null;
    }
  }, PENDO_POLL_INTERVAL_MS);
}

export function initializePendo(user = {}) {
  if (typeof window === 'undefined') {
    return;
  }

  if (!user.uuid || !user.email) {
    return;
  }

  const visitor = {
    id: String(user.uuid),
    email: user.email,
  };

  if (user.role) {
    visitor.role = user.role;
  }

  if (user.sub_role) {
    visitor.sub_role = user.sub_role;
  }

  pendingVisitor = visitor;

  if (pendoReady()) {
    sendVisitor(visitor);
    return;
  }

  waitForPendo();
}
